import { SubmissionError } from 'redux-form'
import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/UpdateStudentConstants'

export const fetchStudentLocation =
  ({ studentId }) =>
  async dispatch => {
    dispatch({ type: c.FETCH_STUDENT_LOCATION_PENDING })
    try {
      const { data } = await axios.get(
        `${Config.API_URL}/students/registrations/students/${studentId}/location`
      )
      dispatch({ type: c.FETCH_STUDENT_LOCATION_FULFILLED, payload: data })
    } catch (err) {
      dispatch({ type: c.FETCH_STUDENT_LOCATION_REJECTED, payload: getServerErrorMessage(err) })
    }
  }

export const updateStudentLocation =
  ({ studentId, provinceCode }) =>
  async dispatch => {
    dispatch({ type: c.UPDATE_STUDENT_LOCATION_PENDING })
    try {
      await axios.put(`${Config.API_URL}/students/registrations/students/${studentId}/location`, {
        provinceCode,
      })
      dispatch({ type: c.UPDATE_STUDENT_LOCATION_FULFILLED })
    } catch (err) {
      const error = getServerErrorMessage(err)
      dispatch({ type: c.UPDATE_STUDENT_LOCATION_REJECTED, payload: error })
      throw new SubmissionError({ _error: error })
    }
  }

export const resetStudentLocation = () => dispatch => dispatch({ type: c.RESET_STUDENT_LOCATION })
